/**
 * Secure token storage utility.
 * Uses sessionStorage by default (cleared on tab close).
 * Token/auth data MUST use sessionStorage (XSS-safe vs localStorage).
 * Non-sensitive preferences (theme, UI state) may use localStorage.
 */
const STORAGE = window.sessionStorage;
const TOKEN_KEY = "nm_token";
const THEME_KEY = "nm-theme";

export const tokenStorage = {
  get: () => STORAGE.getItem(TOKEN_KEY),
  set: (token) => STORAGE.setItem(TOKEN_KEY, token),
  remove: () => STORAGE.removeItem(TOKEN_KEY),
};

// Theme can safely use localStorage (not sensitive)
export const themeStorage = {
  get: () => localStorage.getItem(THEME_KEY) || "dark",
  set: (theme) => localStorage.setItem(THEME_KEY, theme),
};
